// @ts-nocheck
  //background: ${props => props.primary ? "navy" : "#4CAF50"};

//import logo from './logo.svg';
import styled from 'styled-components';
import { useMemo, useRef, useState, useEffect, createContext, useContext } from 'react';

const Butn=styled.button`
  background: "#CDCDCD";
  border: none;
  color: black;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
`

const Fleg=styled.div`
  display: flex;
`

const spacer={paddingLeft: '2vw'}

const Col=styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  background-color: #a57a5a;
  text-align: center;
  margin-left: 1vw;
  margin-right: 1vw;
  margin-bottom: 1vh;
`

const palette=["#a57a5a","#9addfb","blue","navy","red","pink","green","yellow","orange","purple","#cc9c80","brown","white","gray","black"];

const pword=["#a57a5a","yellow","#9addfb","red","#7fff00","orange","white","gray"];

const textlist=["-","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"]

const textstyle={margin: 'auto',}

const Color = ({color}) => {
	const [index,setIndex]=useState(color);
	function setColour(value){
		if (textlist[num]=="-") {
			let val=(value+1) % (palette.length);
			setIndex(val);
		} 
	}
	useEffect(()=> {
		setIndex(color)
	}, [color]);
	const [num,setNum]=useState(0);
	function setList(value){
		let val=(value+1) % (textlist.length);
		setNum(val);
	}
	return (
		<>
			<Col style={{backgroundColor: palette[index]}} onClick={()=>setColour(index)}><p></p></Col>
		</>
	)
}

const Worder = ({color}) => {
	const [index,setIndex]=useState(color);
	function setColour(value){
		if (textlist[num]=="-") {
			let val=(value+1) % (pword.length);
			setIndex(val);
		} 
	}
	useEffect(()=> {
		setIndex(color)
	}, [color]);
	const [num,setNum]=useState(0);
	function setList(value){
		let val=(value+1) % (textlist.length);
		setNum(val);
	}
	return (
		<>
			<Col style={{backgroundColor: pword[index]}} onClick={()=>setColour(index)}><p onClick={()=>setList(num)}>{textlist[num]}</p></Col>
		</>
	)
}

const MakeBoard = ({values}) => {
	const [back,setBack]=useState(1);
	const [fore,setFore]=useState(0);
	const [count,setCount]=useState(0);
	const [word,setWord]=useState(false);
	const size=Math.sqrt(values.length);
	let bx=Array.from({ length: Math.ceil(values.length / size) }, (v, i) => values.slice(i * size, i * size + size));
        const board = useMemo(() =>
		bx.map((item)=> <div style={{backgroundColor: palette[back]}}><Fleg>{item.map((x)=> <Color color={fore} />)}</Fleg></div>),
                [fore,back]
        );
        const woard = useMemo(() =>
		bx.map((item)=> <div style={{backgroundColor: palette[back]}}><Fleg>{item.map((x)=> <Worder color={fore} />)}</Fleg></div>),
                [fore,back]
        );
	function setBackground(value){
		let val=(value+1) % (palette.length);
		setBack(val);
	}
	function setFrontground(value){
		let val=(value+1) % (palette.length);
		setFore(val);
		console.log(fore);
	}
	return (
		<>
		<div onClick={()=>setCount(count+1)} style={{paddingTop: '1vh', backgroundColor: palette[back],}}>
		{ word ? woard : board}
		</div>
		<p onClick={()=>setBackground(back)}><Butn >back</Butn></p>
		<p onClick={()=>setFrontground(fore)}><Butn>front</Butn></p>
		<p onClick={()=>setWord(word => !word)}><Butn >word</Butn></p>
		<p onClick={()=>setCount(count-1)}><Butn>{count}</Butn></p>
		</>
	)
}

function boardgrid(row,col) {
  let i=Array.from(Array(row).keys());
  let j=Array.from(Array(col).keys());
  let xy=i.map((x)=>j.map((y)=>([x,y]))).flat();
  return xy;
}

function Board() {
	const [values,setValues]=useState(boardgrid(10,10));
	return (
		<>
		<MakeBoard values={values} />
 		</>
	)
}

export default Board;
